import axios from './client';

const REPORTS_APPLICATIONS = '/reports-applications';
const REPORTS_COMMISSIONS = '/reports-commissions';

export default function applications(params = {}) {
  return axios.get(REPORTS_APPLICATIONS, { params });
}

export function commissions(params = {}) {
  return axios.get(REPORTS_COMMISSIONS, { params });
}
